import { Chip } from '@mui/material';
import { forwardRef } from 'react';
import { invoiceStatusEnum, invoiceStatusMap } from '../../Configurations/invoicingConfig';

const INVOICING_STATUS_COLORS = {
    [invoiceStatusEnum.PreInvoiced]: 'success',
    [invoiceStatusEnum.Invoiced]: 'success',
    [invoiceStatusEnum.Errored]: 'error',
    [invoiceStatusEnum.Abandoned]: 'warning',
    [invoiceStatusEnum.Outdated]: 'grey',
};

const StatusPill = forwardRef(
    ({ content, variant = 'lt-admin-pill', status, sx, ...rest }, ref) => (
        <Chip
            ref={ref}
            variant={variant}
            label={invoiceStatusMap[status] || status}
            color={INVOICING_STATUS_COLORS[status] || 'default'}
            sx={{
                justifyContent: 'flex-start',
                minWidth: 105,
                '& .MuiChip-label': {
                    display: 'flex',
                    flexGrow: 1,
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                    rowGap: 2,
                },
                ...(sx || {}),
            }}
            {...rest}
        />
    )
);

export default StatusPill;
